import { Injectable } from '@angular/core';
import { ResponseModel, SessionTokenModel } from '../../api';
import { LocalStorageService } from './local-storage/local-storage.service';

export interface SessionToken {
  token: string;
  phoneNumber: string;
  countryCode: string;
  time: number
}

@Injectable({
  providedIn: 'root'
})
export class RegTokenService extends LocalStorageService<SessionToken> {

  constructor () {
    super('REG_TOKEN');
  }

  save(phone) {
    return (res: ResponseModel<SessionTokenModel>) => {
      this.value = {
        countryCode: '375',
        phoneNumber: phone,
        token: res.data.token,
        time: Date.now()
      };
    }
  }
}
